import React from 'react';
import Frame from './frame';
import request from '../../service/request';
import { NEWHOUSE_GET_MODELINFO } from '../../service/api';

async function action ({ query, cookie }) {

    const bigNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];

    const houseData = await request.GET({
        url: NEWHOUSE_GET_MODELINFO + query.id,
        headers: cookie ? {
            cityCode: cookie['cityCode'] || 420200
        } : {}
    });

    const cleanFrameData = (houseInfo) => {
        const newFrameInfo = {
            type: [],
            datasouse: [],
            selectIndex: query.frame?parseInt(query.frame): 0
        };
        newFrameInfo.datasouse = houseInfo.newHouseModelInfo.sort(function (a, b) {
            return (a.rooms - b.rooms);
        });

        newFrameInfo.datasouse = groupBy(houseInfo.newHouseModelInfo, (item) => {
            return [item.rooms];
        });
        newFrameInfo.datasouse.forEach((item, index) => {
            newFrameInfo.type.push(`${bigNum[item[0].rooms]}居室(${newFrameInfo.datasouse[index].length})`);
        });

        newFrameInfo.type.push(`全部户型(${houseInfo.newHouseModelInfo.length})`);
        newFrameInfo.datasouse.push(houseInfo.newHouseModelInfo);
        return newFrameInfo;
    }

    const groupBy = (array, f) => {
        const groups = {};
        array.forEach((o) => {
            const group = JSON.stringify(f(o));
            groups[group] = groups[group] || [];
            groups[group].push(o);
        });
        return Object.keys(groups).map(function (group) {
            return groups[group];
        });
    }

    const pData = {
        id: query.id || '',
        houseInfo: houseData.data,
        loading: false,
        frameInfo: cleanFrameData(houseData.data),
        pageCode: houseData.code
    };

    return {
        title: `${pData.houseInfo.newHouseName}_楼盘户型_东楚优房`,
        chunks: ['frame'],
        component: (
            <Frame pagedata={pData} />
        )
    };
}
export default action;
